// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>KING SOLARMAN</h3>
            <p>Your trusted partner for quality power solutions in Botswana.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/products">Products</Link>
            <Link to="/contact">Contact</Link>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📞 +267 72 222 222</p>
            <p>✉️ info@kingsolarman.co.bw</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 KING SOLARMAN. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
